import React from 'react'

export const Reports = () => {
  return (
    <div>Reports building soon.....</div>
  )
}
